import { Heading, Link as ChakraLink, Spinner } from '@chakra-ui/react';
import { useWeb3React } from 'hooks/web3';
import { FC, useMemo } from 'react';
import { useConnection } from 'store/connection';
import { Link } from 'react-router-dom';
import { usePrograms } from 'hooks/query/usePrograms';
import { ConnectWallet } from 'components/manage/ConnectWallet';
import RewardProgramsList from 'components/rewardPrograms/RewardProgramsList';

const Manage: FC = () => {
  const { data } = usePrograms();
  const { account } = useWeb3React();
  const { tried } = useConnection();

  const filteredPrograms = useMemo(() => {
    if (data && account) {
      return data.filter(
        (d) =>
          d.rewardProgram.owner === account.toLowerCase() ||
          d.rewardProgram.powerSwitchController === account.toLowerCase()
      );
    }
  }, [data, account]);

  if (!tried) {
    return <Spinner />;
  }

  if (tried && !account) {
    return (
      <ConnectWallet headingText='Connect your wallet to manage your Reward Programs.' />
    );
  }

  if (filteredPrograms && filteredPrograms.length === 0) {
    return (
      <Heading size='lg' textAlign='center' mb={4}>
        You don't own any Reward Programs.
        <br />
        Go to the{' '}
        <ChakraLink
          as={Link}
          to='/onboarding'
          color='cyan.500'
          textDecor='underline'
        >
          Onboarding
        </ChakraLink>{' '}
        page to create one.
      </Heading>
    );
  }

  return (
    <>
      <Heading size='xl' textAlign='center' py={8}>
        Manage Your Reward Programs
      </Heading>
      <RewardProgramsList
        programs={filteredPrograms}
        showExpiredPrograms
        showUnverified={true}
      />
    </>
  );
};

export default Manage;
